//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "orderdetail",
  data(){
      return {
        orderinfo:{}
      }
  },
  methods:{
      getDetail(){
        this.axios.post('/xcx/User/orderInfo',{order_id:this.$route.query.orderid}).then(res=>{
          this.orderinfo=res.data.data;
        })
      }
  },
  created() {
      this.getDetail();
  }
}



// WEBPACK FOOTER //
// ./src/components/orderdetail/orderdetail.vue